import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { agencyBenefits, agencyChain } from "@/mocks/public";

export default function AgencyShowcaseSection() {
  return (
    <section className="py-16 md:py-24 bg-secondary-950">
      <div className="container-page">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal variant="left">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1 text-xs font-label font-semibold uppercase tracking-wide text-accent-400">
              <i className="ri-building-4-line text-[13px]" aria-hidden="true" />
              Agences immobilières
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-heading font-semibold leading-tight text-background-50">
              Gérez plusieurs propriétaires et plusieurs immeubles
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/85">
              Structurez votre agence : chaque propriétaire, chaque immeuble et chaque bien est correctement rattaché,
              avec des revenus suivis séparément.
            </p>
            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {agencyBenefits.map((benefit) => (
                <li key={benefit} className="flex items-start gap-2 text-sm text-background-100/90">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-400" aria-hidden="true" />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <Link
                to="/solutions"
                className="group inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-label font-medium text-secondary-950 hover:bg-accent-400 hover:-translate-y-0.5 transition-all cursor-pointer"
              >
                Découvrir la solution agence
                <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
              </Link>
            </div>
          </Reveal>

          <Reveal variant="right" className="img-zoom w-full h-[320px] md:h-[460px] overflow-hidden rounded-lg border border-background-50/15">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20professional%20real%20estate%20team%20reviewing%20documents%20around%20a%20wooden%20table%20in%20a%20bright%20modern%20office%2C%20terracotta%20and%20cream%20color%20palette%2C%20soft%20natural%20light%2C%20minimal%20interior%2C%20elegant%20composition%2C%20high%20detail&width=1000&height=800&seq=agency-immogest-01&orientation=landscape"
              alt="Équipe d'agence immobilière gérant plusieurs propriétaires"
              title="Gestion immobilière pour agences — ImmoBF"
              className="h-full w-full object-cover object-top"
            />
          </Reveal>
        </div>

        <Reveal variant="up" className="mt-14 rounded-lg border border-background-50/15 bg-background-50/5 p-5 md:p-6">
          <p className="text-center text-xs font-label font-semibold uppercase tracking-wide text-accent-400">
            Hiérarchie de gestion
          </p>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-2 md:gap-3">
            {agencyChain.map((node, index) => (
              <Reveal key={node.label} delay={index * 70} className="flex items-center gap-2 md:gap-3">
                <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-3.5 py-2 text-xs md:text-sm font-label font-medium text-background-50">
                  <i className={node.icon} aria-hidden="true" />
                  {node.label}
                </span>
                {index < agencyChain.length - 1 && (
                  <i className="ri-arrow-right-line text-background-200/60" aria-hidden="true" />
                )}
              </Reveal>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}